import React from 'react';
import clsx from 'clsx';
import { translate } from '../../../Services/translation';

const AddressListItemDesktop = ({ address }: { address: any }) => {
  const columnClassName =
    'text-base text-ellipsis overflow-hidden whitespace-nowrap';

  return (
    <div
      className={clsx(
        'grid',
        'grid-cols-5',
        'items-center',
        'px-2',
        'gap-4',
        'py-1'
      )}
    >
      <p className={columnClassName}>{address.address}</p>
      <p className={columnClassName}>{address.zipCode}</p>
      <p className={columnClassName}>{address.city}</p>
      <p className={columnClassName}>{address.country}</p>
      {address.addressType && (
        <p className={columnClassName}>
          {translate(
            'mypage.address.type.' + address.addressType.toLowerCase()
          )}
        </p>
      )}
    </div>
  );
};
export default AddressListItemDesktop;
